module.exports = __webpack_public_path__ + "img/Bodice-Back-Jc-Kh-La.aa99b1f8.png";